module.exports = __webpack_public_path__ + "static/media/order_icon27.a7996870.png";